import ReadOnly from '../../components/ReadOnly'
import * as Vendor from '@/services/rest-api/lib/vendor/vendor'
import VendorStatus from '../../components/VendorStatus.vue'

const translate = (t, key, fallback, params = {}) => {
  if (typeof t !== 'function') return fallback

  const translated = t(key, params)

  return translated === key ? fallback : translated
}

const getDraftFields = (t) => ({
  name: 'vendor_id',
  showKey: 'vendor',
  type: 'vendor-value-help',
  label: translate(t, 'delivery.fields.vendorName', 'Nama Vendor'),
  placeholder: `${translate(t, 'global.form.select', 'Pilih')} ${translate(
    t,
    'delivery.fields.vendorName',
    'Nama Vendor'
  )}`,
  trackBy: 'id',
  displayedBy: 'name',
  listGetter: Vendor.getRatesWithFilters(['status.name eq ACTIVE', 'paired_company_id gt 0']),
  headerInfoComponent: ReadOnly,
  headerInfoProps: {
    items: [
      {
        key: 'box_type',
        label: translate(t, 'global.field.vehicleType', 'Jenis Kendaraan'),
        bold: true,
        value: '',
      },
      {
        key: 'origin',
        label: translate(t, 'delivery.fields.originCity', 'Kota Asal'),
        bold: true,
        value: '',
      },
      {
        key: 'destination',
        label: translate(t, 'delivery.fields.destinationCity', 'Kota Tujuan'),
        bold: true,
        value: '',
      },
      {
        key: 'total_weight',
        label: translate(t, 'delivery.vendorField.weightTotalKg', 'Total Berat (Kg)'),
        bold: true,
        value: '',
      },
    ],
  },
  tableFields: [
    {
      label: translate(t, 'delivery.fields.vendorName', 'Nama Vendor'),
      key: 'name',
    },
    {
      label: translate(t, 'delivery.vendorField.connected', 'Terhubung'),
      key: 'status.name',
      name: 'status',
      isSlot: true,
      slotComponent: VendorStatus,
      thStyle: 'text-align:center;',
      tdAttr: {
        style: 'text-align:center;',
      },
    },
    {
      label: translate(t, 'delivery.vendorField.contractNumber', 'Nomor Kontrak'),
      key: 'contract_number',
    },
    {
      label: translate(t, 'delivery.vendorField.rate', 'Tarif'),
      key: 'base_price',
      formatter: (value) => (value ? value.toLocaleString() : value),
    },
    {
      label: translate(t, 'delivery.vendorField.origin', 'Asal'),
      key: 'origin',
    },
    {
      label: translate(t, 'delivery.vendorField.destination', 'Tujuan'),
      key: 'destination',
    },
    {
      label: translate(t, 'master.form.fleet.boxTypeV2', 'Jenis Box'),
      key: 'box_type',
    },
    {
      label: translate(t, 'delivery.vendorField.weightCapacity', 'Kapasitas Berat (Kg)'),
      key: 'total_weight',
      formatter: (value) => (value ? value.toLocaleString() : value),
    },
    {
      label: translate(t, 'delivery.vendorField.volumeCapacity', 'Kapasitas Volume (Cbm)'),
      key: 'total_volume',
      formatter: (value) => (value ? value.toLocaleString() : value),
    },
  ],
})

const getConfirmedFields = (t) => ({
  ...getDraftFields(t),
  disabled: true,
})

const getVendorFields = (t, _locale) => ({
  Draf: getDraftFields(t),
  Dikonfirmasi: getDraftFields(t),
  'Menunggu Vendor': getConfirmedFields(t),
  Ditolak: getDraftFields(t),
  'Diterima Vendor': getConfirmedFields(t),
  Dijadwalkan: getConfirmedFields(t),
  'Dijadwalkan Ulang': getConfirmedFields(t),
  Dijalankan: getConfirmedFields(t),
  Diambil: getConfirmedFields(t),
  Terkirim: getConfirmedFields(t),
  Dibatalkan: getConfirmedFields(t),
  'Sedang Transit': getConfirmedFields(t),

  default: getDraftFields(t),
})

export default getVendorFields
